import { createApp } from '@backstage/frontend-defaults';
import { createFrontendFeatureLoader } from '@backstage/frontend-plugin-api';
import authPlugin from '@backstage/plugin-auth';
import notificationsPlugin from '@backstage/plugin-notifications/alpha';
import signalsPlugin from '@backstage/plugin-signals/alpha';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';
import { authModule } from './modules/auth';
import { gitlabCiModule } from './modules/gitlab-ci';
import { navModule } from './modules/nav';
import {
  catalogEndStateModule,
  catalogEndStatePlugin,
} from './modules/catalog-end-state';
import { verdantThemeModule } from './theme';
import databaseSubsettingPlugin from './modules/database-subsetting';

const integrationsFeatureLoader = createFrontendFeatureLoader({
  async loader() {
    const [search, kubernetes, argocd, techdocs] = await Promise.all([
      import('@backstage/plugin-search/alpha'),
      import('@backstage/plugin-kubernetes/alpha'),
      import('@backstage-community/plugin-argocd'),
      import('@backstage/plugin-techdocs/alpha'),
    ]);

    return [
      search.default,
      kubernetes.default,
      argocd.default,
      techdocs.default,
    ];
  },
});

export default createApp({
  features: [
    catalogEndStatePlugin,
    catalogEndStateModule,
    authPlugin,
    integrationsFeatureLoader,
    notificationsPlugin,
    signalsPlugin,
    userSettingsPlugin,
    gitlabCiModule,
    authModule,
    navModule,
    verdantThemeModule,
    databaseSubsettingPlugin,
  ],
});
